export const [
  UNSET_QUESTION,
  SET_QUESTION,
  NEXT_QUESTION,
  PREVIOUS_QUESTION,
  CREATE_QUESTION,
  SUBMIT_SURVEY_REQUEST,
  SUBMIT_SURVEY_SUCCESS,
  SUBMIT_SURVEY_ERROR,
  INIT_SURVEY,
  CANCEL_SURVEY,
  SET_CUSTOMER_TYPE,
  REMOVE_QUESTION,
  RESET_SURVEY_STORE,
  GET_ALL_DOCUMENT,
  GET_ALL_DOCUMENT_REQUESTS,
  ADD_DOCUMENTS_TO_QUESTION,
  RESET_SURVEY_QUESTION_REPLIES,
  SET_VITALS_ANSWERS,
  REPLACE_QUESTIONS,
  VITALS_COMPLETED,
  SEND_REPORT_TO_MT_CONSENT,
] = [
  "UNSET_QUESTION",
  "SET_QUESTION",
  "NEXT_QUESTION",
  "PREVIOUS_QUESTION",
  "CREATE_QUESTION",
  "SUBMIT_SURVEY_REQUEST",
  "SUBMIT_SURVEY_SUCCESS",
  "SUBMIT_SURVEY_ERROR",
  "INIT_SURVEY",
  "CANCEL_SURVEY",
  "SET_CUSTOMER_TYPE",
  "REMOVE_QUESTION",
  "RESET_SURVEY_STORE",
  "GET_ALL_DOCUMENT",
  "GET_ALL_DOCUMENT_REQUESTS",
  "ADD_DOCUMENTS_TO_QUESTION",
  "RESET_SURVEY_QUESTION_REPLIES",
  "SET_VITALS_ANSWERS",
  "REPLACE_QUESTIONS",
  "VITALS_COMPLETED",
  "SEND_REPORT_TO_MT_CONSENT"
]

export const [
  QUESTION_DOCTORS,
  QUESTION_PATIENT,
  QUESTION_RELATIVES,
  QUESTION_SLOTS,
] = [
  "QUESTION_DOCTORS",
  "QUESTION_PATIENT",
  "QUESTION_RELATIVES",
  "QUESTION_SLOTS",
]

export const RESET_SURVEY_REPLY = "RESET_SURVEY_REPLY"
export const RESET_ANAMNESIS = "RESET_ANAMNESIS"
export const HYDRATE_SURVEY = "HYDRATE_SURVEY"
export const REMOVE_FAMILY_DOCTOR = "REMOVE_FAMILY_DOCTOR"
export const JUMP_TO_QUESTION = "JUMP_TO_QUESTION"
export const CLEAR_RESTORED_DOC_SELECTION = "CLEAR_RESTORED_DOC_SELECTION"
export const REMOVE_FROM_PATH = "REMOVE_FROM_PATH"
export const SET_DOCUMENT_NAVIGATION_LOADING = "SET_DOCUMENT_NAVIGATION_LOADING"
export const FETCH_LATEST_ANAMNESIS = "FETCH_LATEST_ANAMNESIS"
export const SET_LATEST_ANAMNESIS = "SET_LATEST_ANAMNESIS"
export const PREFILL_ANAMNESIS = "PREFILL_ANAMNESIS"
